/**
 * Push 권한 "거부 → 설정으로 이동" 확인 다이얼로그 상태 (in-memory, no persist).
 *
 * ensurePushPermission() 이 denied 상태에서 allowSettingsPrompt=true 로 호출되면
 * openSettings() 로 다이얼로그를 띄우고, PushPermissionGate 가 이를 구독해 렌더.
 */
import { create } from "zustand";

interface PushPromptStore {
  settingsOpen: boolean;
  openSettings: () => void;
  close: () => void;
}

export const usePushPromptStore = create<PushPromptStore>()((set) => ({
  settingsOpen: false,
  openSettings: () => set({ settingsOpen: true }),
  close: () => set({ settingsOpen: false }),
}));
